var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    id: "svg48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0,0.69996 C 0,0.31335 0.31335,0 0.699961,0 H 6.99997 V 1.39992 H 1.39986 V 12.6001 H 12.6001 V 7.00003 H 14 V 13.3 C 14,13.6867 13.6867,14 13.3,14 H 0.700021 C 0.31341,14 5.99671e-5,13.6867 5.99671e-5,13.3 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 11.2505,0 c 0.1856,0 0.3636,0.07371 0.495,0.20496 l 2.0488,2.04879 c 0.2733,0.2734 0.2733,0.71661 0,0.99 L 7.64786,9.39016 C 7.53208,9.5059 7.37939,9.5775 7.21625,9.5923 L 4.96262,9.7973 C 4.75567,9.8161 4.55117,9.7421 4.40423,9.5951 4.2574,9.44829 4.18333,9.24367 4.20208,9.03673 L 4.40692,6.7831 C 4.42181,6.61997 4.49329,6.46729 4.60919,6.35149 L 10.7556,0.20508 C 10.8868,0.07383 11.0649,1.2e-4 11.2505,1.2e-4 Z m -0.854,2.54391 1.0589,1.0588 0.854,-0.85396 -1.0589,-1.05879 z M 10.4654,4.59271 9.40652,3.5338 5.77832,7.162 5.6725,8.32672 6.83722,8.2209 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1a3921d6ba2c6aa3476da216ba1c38ba.svg";
export { ForwardRef as ReactComponent };